"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceData = class UcInvoiceData extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onSaveNotes(...args) {
        console.log(this.invoice.notes);
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    leftColumnLabelCols;
    ux;
    dataMembers = ['leftColumnLabelCols', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                leftColumnLabelCols: 4,
                ux: null,
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return false;
        }
        return null;
    }
    get invoiceTypeName() {
        if (this.loaded) {
            return this.invoice.invoice_type === "correction" ? this.$fn.pgettext("InvoiceType", "Correction") :
                (this.invoice.invoice_type === "storno" ? this.$fn.pgettext("InvoiceType", "Storno") :
                    (this.invoice.invoice_type === "proforma" ? this.$fn.pgettext("InvoiceType", "Pro Forma") : "?"));
        }
        return null;
    }
    async act_4337851679292638_emit_7232_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_4337851679292638_request_7230_getActionArgs($event) {
        return {
            operation: "update_invoice_notes",
            data: { id: this.invoice.id, text: $event.data.value.text },
        };
    }
    async evh_4337851679292638_save(event, scope) {
        return await this.actions.evh_4337851679292638_save.executeFromDOM(this, event, scope);
    }
    async act_4152404563918957_emit_7234_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4152404563918957_reload(event, scope) {
        return await this.actions.evh_4152404563918957_reload.executeFromDOM(this, event, scope);
    }
    async act_3855552110905499_emit_7236_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3855552110905499_reload(event, scope) {
        return await this.actions.evh_3855552110905499_reload.executeFromDOM(this, event, scope);
    }
    async act_4039445435535707_emit_7238_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4039445435535707_reload(event, scope) {
        return await this.actions.evh_4039445435535707_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_4337851679292638_emit_7232 = new core_1.actions.EmitAction({
            actionArgs: this.act_4337851679292638_emit_7232_getActionArgs,
            events: [],
        });
        const evh_4337851679292638_success_7231 = new core_1.actions.EventHandlerImpl({
            action: act_4337851679292638_emit_7232,
            event: "success",
            displayName: "emit",
        });
        const act_4337851679292638_request_7230 = new core_1.actions.RequestAction({
            actionArgs: this.act_4337851679292638_request_7230_getActionArgs,
            displayName: "saveNotes",
            events: [evh_4337851679292638_success_7231],
        });
        const evh_4337851679292638_save_7229 = new core_1.actions.EventHandlerImpl({
            action: act_4337851679292638_request_7230,
            event: "save",
            displayName: "saveNotes",
        });
        const evh_4337851679292638_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4337851679292638_save_7229],
        });
        const act_4152404563918957_emit_7234 = new core_1.actions.EmitAction({
            actionArgs: this.act_4152404563918957_emit_7234_getActionArgs,
            events: [],
        });
        const evh_4152404563918957_reload_7233 = new core_1.actions.EventHandlerImpl({
            action: act_4152404563918957_emit_7234,
            event: "reload",
            displayName: "emit",
        });
        const evh_4152404563918957_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4152404563918957_reload_7233],
        });
        const act_3855552110905499_emit_7236 = new core_1.actions.EmitAction({
            actionArgs: this.act_3855552110905499_emit_7236_getActionArgs,
            events: [],
        });
        const evh_3855552110905499_reload_7235 = new core_1.actions.EventHandlerImpl({
            action: act_3855552110905499_emit_7236,
            event: "reload",
            displayName: "emit",
        });
        const evh_3855552110905499_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3855552110905499_reload_7235],
        });
        const act_4039445435535707_emit_7238 = new core_1.actions.EmitAction({
            actionArgs: this.act_4039445435535707_emit_7238_getActionArgs,
            events: [],
        });
        const evh_4039445435535707_reload_7237 = new core_1.actions.EventHandlerImpl({
            action: act_4039445435535707_emit_7238,
            event: "reload",
            displayName: "emit",
        });
        const evh_4039445435535707_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4039445435535707_reload_7237],
        });
        return {
            act_4337851679292638_emit_7232,
            evh_4337851679292638_success_7231,
            act_4337851679292638_request_7230,
            evh_4337851679292638_save_7229,
            evh_4337851679292638_save,
            act_4152404563918957_emit_7234,
            evh_4152404563918957_reload_7233,
            evh_4152404563918957_reload,
            act_3855552110905499_emit_7236,
            evh_3855552110905499_reload_7235,
            evh_3855552110905499_reload,
            act_4039445435535707_emit_7238,
            evh_4039445435535707_reload_7237,
            evh_4039445435535707_reload,
            saveNotes: act_4337851679292638_request_7230,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceData.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceData.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], UcInvoiceData.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceData.prototype, "onForm_id", null);
UcInvoiceData = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceData);
exports.default = UcInvoiceData;
vue_property_decorator_1.Vue.component("UcInvoiceData", UcInvoiceData);
